export const ORDER_POPUP = "DIALOG_ORDER_POPUP";
export const HOLDING_POPUP = "DIALOG_HOLDING_POPUP";
